import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectProps,
} from '@mui/material';
import { MetadataDataType } from 'generated/graphql';
import { ReactNode } from 'react';

interface SelectMetadataDataTypeProps {
  isOpen?: boolean;
  value: MetadataDataType | undefined;
  onChange: (value: MetadataDataType) => void;
  onClose?: () => void;
  size?: SelectProps['size'];
  label?: ReactNode;
}

export const SelectMetadataDataType = ({
  isOpen,
  value,
  onChange,
  onClose,
  size = 'medium',
  label,
}: SelectMetadataDataTypeProps) => {
  return (
    <FormControl fullWidth required>
      {label && (
        <InputLabel id="select-metadata-data-type-label">{label}</InputLabel>
      )}
      <Select
        open={isOpen}
        onClose={onClose}
        size={size}
        label={label}
        labelId="select-metadata-data-type-label"
        id="select-metadata-data-type"
        value={value}
        onChange={(e) => onChange(e.target.value as MetadataDataType)}
        displayEmpty
        renderValue={
          !value
            ? () => (
                <Box
                  sx={{
                    color: (theme) => theme.palette.grey[500],
                  }}
                >
                  Select data type
                </Box>
              )
            : undefined
        }
      >
        <MenuItem value={MetadataDataType.String}>String</MenuItem>
        <MenuItem value={MetadataDataType.Number}>Number</MenuItem>
        <MenuItem value={MetadataDataType.Boolean}>Boolean</MenuItem>
      </Select>
    </FormControl>
  );
};
